export default __webpack_public_path__ + "static/media/008-international.b07a48de.png";